<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <div class="activity-new">
                    <div class="activity-new-card is-hover-shadow">
                        <div class="step">
                            <el-steps :active="active" finish-status="success"  align-center>
                            <el-step  v-for="item in stepList" :key="item.index" :title="item.title">
                                <span v-if="item.name" slot="description" style="color: #cd1231;">({{ item.name }})</span>
                            </el-step>
                            </el-steps>
                        </div>
                    </div>
                </div>
                <div class="mask" v-if="isMask"></div>
                <div class="title"  style="margin-top: 20px;">
                    <i @click="collClick('orderShow1')" style="cursor: pointer;" :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span @click="collClick('orderShow1')" style="cursor: pointer;">活动主题信息</span>
                </div>
                <div class="card-box" v-show="orderShow1">
                    <div class="card is-hover-shadow" >
                        <div class="left" v-if="activityInfo.themeInfoDTO">
                            <div class="left-top">
                                <div class="left">
                                    <div class="top-name">{{activityInfo.themeInfoDTO.themeName}}</div>
                                    <div class="top-sign">{{getBluename(activityInfo.themeInfoDTO.orgLevel)}}</div>
                                </div>
                                <div class="right">
                                        <span>{{getTime(activityInfo.themeInfoDTO.themeStartTime)}}</span>
                                        <span style="margin:0px 10px;">-</span>
                                        <span>{{getTime(activityInfo.themeInfoDTO.themeEndTime)}}</span>
                                    </div>
                            </div>
                            <div class="pr-item-flex" v-if="activityInfo.themeInfoDTO.gpPrDTOList">
                              <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                              <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                            </div>
                            <div class="left-third">
                                <div class="left-third-left">
                                    <span>活动执行数据收集模板</span>
                                    <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                                </div>
                                <div class="left-third-right">
                                    <span class="text">活动执行手册</span>
                                    <span  class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                                        <span @click="viewPdf(activityInfo.themeInfoDTO.manualFileUri)" v-if="activityInfo.themeInfoDTO.manualFileName && activityInfo.themeInfoDTO.manualFileUri">{{ activityInfo.themeInfoDTO.manualFileName }}</span>
                                        <span v-else>暂无附件</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" style="margin-top: 20px;">
                    <i @click="collClick('orderShow2')" style="cursor: pointer;" :class="[orderShow2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span @click="collClick('orderShow2')" style="cursor: pointer;">活动配置信息</span>
                </div>
                <div class="card-box2 is-hover-shadow" v-show="orderShow2">
                    <div class="form">
                    <div class="item">
                        <div class="item-left">活动渠道</div>
                        <div class="item-right">
                            <span>{{activityInfo.themeChannelName}}</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-left">活动形式</div>
                        <div class="item-right">{{ activityInfo.themeStyleName }}</div>
                    </div>
                    <div class="item">
                        <div class="item-left">活动级别</div>
                        <div class="item-right" v-if="activityInfo.themeLevelName">{{activityInfo.themeLevelName}}</div>
                        <div class="item-right" v-else>暂无</div>
                    </div>
                    <div class="item" v-if="activityInfo.themeInfoDTO">
                        <div class="item-left">活动时间</div>
                        <div class="item-right" style="display: flex;justify-content: space-between;">
                        <div style="width:80%">
                            <span>{{getTime(activityInfo.themeInfoDTO.themeStartTime)}}</span>
                            <span style="margin:0px 10px;">至</span>
                            <span>{{getTime(activityInfo.themeInfoDTO.themeEndTime)}}</span>
                        </div>
                        <div  @click="collClick('orderShow4')" style="flex:1;color:#409EFF;text-align:left;cursor: pointer;">
                            <span v-if="!orderShow4">查看更多</span>
                            <span v-else>收起</span>
                        </div>
                    </div>
                    </div>
                    </div>
                    <div class="form" style="display:block" v-show="orderShow4">
                        <div class="item-sign" v-if="activityInfo.gpThemeDetailDTO">
                            <div class="sign">
                                <div class="sign-left">场勘</div>
                                <div class="sign-right">
                                    <i v-if="activityInfo.gpThemeDetailDTO.needVerify == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red "></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">搭建</div>
                                <div class="sign-right">
                                    <i v-if="activityInfo.gpThemeDetailDTO.needConstruct == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">临促</div>
                                <div class="sign-right">
                                    <i v-if="activityInfo.gpThemeDetailDTO.needSpr == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">转场</div>
                                <div class="sign-right">
                                    <i v-if="activityInfo.gpThemeDetailDTO.needTransitions == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                        </div>
                        <div class="item" style="width:100%" v-if="getDecorates('all')">
                            <div class="item-left">点位照片</div>
                            <div class="item-right" >
                                <span>{{getDecorates('all')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form" v-show="orderShow4">
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO">
                            <div class="item-left">单场投入预算</div>
                            <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.investUnit">{{formatPrice(activityInfo.gpThemeDetailDTO.investUnit)}}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO && activityInfo.gpThemeDetailDTO.needTransitions == 1">
                            <div class="item-left">道具数量</div>
                            <div class="item-right">{{formatPrice(activityInfo.gpThemeDetailDTO.itemQuantity)}}</div>
                        </div>
                        <div class="item" v-else>
                            <div class="item-left" v-if="activityInfo.gpThemeDetailDTO">
                                <span v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '1'">每售点执行天数</span>
                                <span v-if ="activityInfo.gpThemeDetailDTO.pocRelateType == '2'">每街区执行天数</span>
                                <span v-if ="activityInfo.gpThemeDetailDTO.pocRelateType == '0'">每活动地点执行天数</span>
                            </div>
                            <div class="item-right" v-if="activityInfo.gpThemeDetailDTO">
                                <span>{{formatPrice(activityInfo.gpThemeDetailDTO.perExecDays)}}</span>
                                <span style="margin:0px 0px;">天</span>
                            </div>
                        </div>
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO&&activityInfo.gpThemeDetailDTO.needSpr==1">
                            <div class="item-left">临促人员人数限制</div>
                            <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.pgQtyLimit">{{ formatPrice(activityInfo.gpThemeDetailDTO.pgQtyLimit) }}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO&&activityInfo.gpThemeDetailDTO.needSpr==1">
                            <div class="item-left">打卡/执行信息上传方式</div>
                            <div class="item-right" v-if="activityInfo.gpThemeDetailDTO.needPerformance == 1">督导统一上传</div>
                            <div class="item-right" v-else>临促人员自行上传</div>
                        </div>
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO" style="width:100%">
                            <div class="item-left">活动SKU</div>
                            <div class="item-right" >
                                <!-- <span>{{getSKU(activityInfo.gpThemeDetailDTO.skuDTOList,'、')}}</span> -->
                                <span v-if="activityInfo.gpThemeDetailDTO.skuDTOList && activityInfo.gpThemeDetailDTO.skuDTOList.length > 0">
                                    <el-tag
                                        style=" margin:0 10px 8px 0px;cursor: pointer;"
                                        v-for="tag in activityInfo.gpThemeDetailDTO.skuDTOList"
                                        :key="tag.skuCode"
                                        type="info">
                                        {{tag.skuName}}
                                    </el-tag>
                                </span>
                                <span v-else>暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" style="margin-top: 20px;">
                    <i  @click="collClick('orderShow3')" style="cursor: pointer;" :class="[orderShow3 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    <span  @click="collClick('orderShow3')" style="cursor: pointer;">提报要求</span>
                </div>
                <div class="card-box3 is-hover-shadow"  v-show="orderShow3">
                    <div class="form" v-if="activityInfo.gpThemeDetailDTO">
                        <div class="item">
                            <div class="item-left">提报售点要求</div>
                            <div class="item-right">
                                <span>{{getpocRelateType(activityInfo.gpThemeDetailDTO)}}</span>
                            </div>
                        </div>
                        <div class="item" v-if="activityInfo.gpThemeDetailDTO.pocRelateType == '2'">
                            <div class="item-left">最少关联售点设置</div>
                            <div class="item-right">{{formatPrice(activityInfo.gpThemeDetailDTO.pocCountMin)}}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">额度信息</div>
                            <div class="item-right">
                                <div v-for="item in activityInfo.gpThemeDetailDTO.detailDTOList" :key="item.regionCode">
                                    <div v-if="item.totalCountQty > 0">
                                        <span style="margin:0px 5px 0px 0px;">{{getRegionName(item)}}</span>
                                        <span>{{formatPrice(item.totalCountQty)}}{{ showText }}</span>
                                        <span>（已通过：</span>
                                        <span>{{formatPrice(item.passedCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>审核中：</span>
                                        <span>{{formatPrice(item.approvalCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>未提报：</span>
                                        <span>{{formatPrice(item.notReportCountQty)}}{{ showText }}</span>
                                        <span>）</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cross" style="margin-top:-20px" v-if="!loading" >
                    <SubmitPop
                        :dataItem="dataItem"
                        :isAllbtn = 'isAllbtn'
                        :queryCondition="queryCondition"
                        @passThrough ='passThrough'
                        @sendBack = 'sendBack'
                        @clickStorename = 'clickStorename'
                        >
                    </SubmitPop>
                </div>
                <div v-if="showChangepop" class="changePop">
                    <configBuChangePop
                    @closeChangepop="closeChangepop"
                    :themeId="activityInfo.themeId"
                    ></configBuChangePop>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from "@/utils/common";
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import SubmitPop from './components/submit-approval-pop.vue'
    import DialogPop from './components/dialog-pop.vue'
    import configBuChangePop from './components/config-buChange-pop.vue'
    export default {
      name: 'submit-approval-detail',
      components: {
        ContentHeader,
        SubmitPop,
        DialogPop,
        configBuChangePop
      },
      data () {
        return {
            active:0,
            stepList:[
                {name:'',index:0,title:'提交'},
                {name:'',index:1,title:'Regin审批'},
                {name:'',index:2,title:'BU审批'},
                {name:'',index:3,title:'HQ审批'},
                {name:'',index:4,title:'完成'},
            ],
            activityInfo: {
                gpPrDTO: {},
                themeInfoDTO: {},
                gpActivityPocDTOList: [],
                imageApprovalList:[]
            },
            themeBasic: {},
            detailList: {},
            channelList:[],
            fullConfig:[],
            themeChannelCodes:[],
            themeId:'',
            activityId:'',
            themeDetailId:'',
            isAllbtn: true,
            isPassThroughall:false, // 是否是全部通过
            isSendbackall:false, // 是否是全部退回
            orderShow:true,
            loading:true,
            queryCondition:'04',
            orgLevel:'',
            rejectAccount:'',
            isMask: false,
            orderShow1: true,
            orderShow2: true,
            orderShow3: true,
            orderShow4: false,
            orderShow5: true,
            showChangepop: false,
            isMask: false,
            themeDetail: {},
            dataItem: {},
            showText:'',
            tableList:[],
            congfigDetail:null,
            prInfo:'',
            brandInfo:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.themeId = this.$route.query.themeId
        this.activityId = this.$route.query.activityId
        this.themeDetailId = this.$route.query.themeDetailId
        if (this.$route.query.routerType == '02') {
            this.isAllbtn = false
        }
        this.employeeLevel = this.userInfo.employeeLevel
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            // this.getConfigfull()
            this.getActivityInfo()
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        //售点查看详情
        viewDetail (row) {
        let params = {
            activityId: row.activityId,
            activityTime: row.timeSign,
            pocAbiId: row.igniteId
        }
        this.getReportdetail(params)
        this.paramsPop = params
        },
        lockScroll() {
        let widthBar = 17, root = document.documentElement;
        if (typeof window.innerWidth == 'number') {
            widthBar = window.innerWidth - root.clientWidth;
        }
        root.style.overflow = 'hidden';
        root.style.borderRight = widthBar + 'px solid transparent';
        },
        unlockScroll() {
        let root = document.documentElement;
        root.style.overflow = '';
        root.style.borderRight = '';
        },
        viewPdf (url) {
            if (url) {
                window.open(commonUtils.getImageUrl(url))
            } else {
                console.log('manualFileUri为空');
            }
        },
        viewChangepop () {
        this.isMask = true
        this.showChangepop = true
        this.lockScroll()
        },
        closeChangepop () {
        this.isMask = false
        this.showChangepop = false
        this.isShowDetail = false
        this.unlockScroll()
        },
        getSKU (arr,sign) {
        if (arr && arr.length > 0) {
            let name = arr.map((item)=>{
            return item.skuName
            }).join(sign)
            return name
        } else {
            return '暂无数据'
        }
        },
        // 获取配置信息
        async getConfigfull () {
            let {data} = await gameplanApi.getGameplanConfigFull()
            if (data.resultCode == '0') {
                let fullConfig = data.resultData.fullConfig
                for (let item1 of fullConfig) {
                    if (item1.themeChannelCode == this.themeDetail.themeChannelCode) {
                        for (let item2 of item1.themeStyles) {
                            if (item2.themeStyleCode == this.themeDetail.themeStyleCode) {
                                if (this.themeDetail.themeLevelCode && item2.themeLevels.length > 0) {
                                    for (let item3 of item2.themeLevels) {
                                        if (item3.themeLevelCode == this.themeDetail.themeLevelCode) {
                                            this.congfigDetail = item3.themeConfig
                                        }
                                    }
                                } else {
                                    this.congfigDetail = item2.themeConfig
                                }
                            }
                        }
                    }
                }
            }
        },
        // 获取点位信息
        getDecorates (type) {
            if (!this.activityInfo.gpThemeDetailDTO) {
                return
            }
            let data = this.activityInfo.gpThemeDetailDTO.themeDecorates
            let showDecorates = []
            let showExecDecorates = []
            if (data) {
                if (type == 'showDecorates') {
                    if (showDecorates.length > 0) {
                        let name = showDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'showExecDecorates') {
                    if (showExecDecorates.length > 0) {
                        let name = showExecDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'all') {
                    if (data.length > 0) {
                        let name = data.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else {
                    return
                }
            } else {
                return ''
            }
        },
        getpocRelateType (gpThemeDetailDTO) {
            let pocRelateType = gpThemeDetailDTO.pocRelateType
            if (pocRelateType == 0) {
                return this.saleTypename = '无售点'
            }else if (pocRelateType == 1) {
                return this.saleTypename = '单售点'
            } else if (pocRelateType == 2) {
                return this.saleTypename = '多售点'
            } else {
                return this.saleTypename = 'error'
            }
        },
        getRegionName (item) {
            if (item) {
                if (item.regionName) {
                    return item.regionName.split('|')[0] + ":"
                } else {
                    return item.buName.split('|')[0] + ":"
                }
            }else {
                return '无'
            }
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        // 理由
        getRejectaccount (val) {
            this.rejectAccount = val
        },
        getChannel(a,b){
            let themeChannels = a || []
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getShowtext () {
            let needTransitions = this.activityInfo.gpThemeDetailDTO.needTransitions
            let pocRelateType = this.activityInfo.gpThemeDetailDTO.pocRelateType
            if (needTransitions == 0) {
                if (pocRelateType == '0') {
                    this.showText = '地点'
                } else if (pocRelateType == '1') {
                    this.showText = '售点'
                } else if (pocRelateType == '2') {
                    this.showText = '街区'
                }

            } else if (needTransitions == 1) {
                this.showText = '场'
            } else {
                return
            }
        },
        async getDetailinfo () {
            let params = {
                themeId:this.themeId,
                'queryCondition':'10'
            }
            this.loading = true
            let {data} = await gameplanApi.getGamepalnActivityInfo(params)
            if (data.resultCode == '0') {
                this.orgLevel =  data.resultData.themeInfo.themeBasic.orgLevel
                if (this.orgLevel == 'hq') {
                    if  (this.employeeLevel == 60 || this.employeeLevel == 70 || this.employeeLevel == 80 ){
                        this.active = 1
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:'22',index:1,title:'BU审批中'},
                            {name:'33',index:2,title:'HQ审批'},
                            {name:'',index:3,title:'执行中'},
                            {name:'',index:4,title:'完成'},
                        ]

                    } else if  (this.employeeLevel == 90 || this.employeeLevel == 100  ){
                        this.active = 2
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:'',index:1,title:'BU已审批'},
                            {name:'',index:2,title:'HQ审批中'},
                            {name:'',index:3,title:'执行中'},
                            {name:'',index:4,title:'完成'},
                        ]
                    }
                } else if (this.orgLevel == 'bu') {
                    if  (this.employeeLevel == 60 || this.employeeLevel == 70 || this.employeeLevel == 80 ){
                        this.active = 1
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:'',index:1,title:'BU审批中'},
                            {name:'',index:2,title:'执行中'},
                            {name:'',index:3,title:'完成'},
                        ]

                    } else if  (this.employeeLevel == 90 || this.employeeLevel == 100  ){
                        this.active = 2
                        this.stepList = [
                            {name:'',index:0,title:'提交'},
                            {name:'',index:1,title:'BU已审批'},
                            {name:'',index:2,title:'执行中'},
                            {name:'',index:3,title:'完成'},
                        ]
                    }
                } else {
                    return
                }
                this.getShowtext()
                this.loading = false
            } else {
                this.loading = false
            }
        },
        getShowDetail(){
          const themeBasic = this.activityInfo.themeInfoDTO || {}
          let brandInfo = []
          let prInfo = []
          const gpPrDTOList = themeBasic.gpPrDTOList
          if(gpPrDTOList){
            gpPrDTOList.forEach(item=>{
              let data = ''
              if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
              else data = item.brandName||item.subBrandName
              if(brandInfo.indexOf(data)===-1) {
                brandInfo.push(data)
              }
              prInfo.push(item.prNumber+'-'+item.prName)
            })
            console.log(brandInfo);
            this.brandInfo = brandInfo.join('、')
            this.prInfo = prInfo.join('、')
          }
        },
        async getActivityInfo() {
        let params = {
            activityId: this.activityId,
        };
        this.loading = true
        let res = await gameplanApi.getActivityApprovePhotoInfo(params)
        if (res.data.resultCode === '0') {
            let activityInfo = res.data.resultData.activityInfo || {}
            this.orgLevel =  activityInfo.themeInfoDTO.orgLevel
            if (this.orgLevel == 'hq') {
                if  (this.employeeLevel == 60 || this.employeeLevel == 70 || this.employeeLevel == 80 ){
                    this.active = 1
                    this.stepList = [
                        {name:'',index:0,title:'提交'},
                        {name:'',index:1,title:'BU审批中'},
                        {name:'',index:2,title:'HQ审批'},
                        {name:'',index:3,title:'执行中'},
                        {name:'',index:4,title:'完成'},
                    ]

                } else if  (this.employeeLevel == 90 || this.employeeLevel == 100  ){
                    this.active = 2
                    this.stepList = [
                        {name:'',index:0,title:'提交'},
                        {name:'',index:1,title:'BU已审批'},
                        {name:'',index:2,title:'HQ审批中'},
                        {name:'',index:3,title:'执行中'},
                        {name:'',index:4,title:'完成'},
                    ]
                }
            } else if (this.orgLevel == 'bu') {
                if  (this.employeeLevel == 60 || this.employeeLevel == 70 || this.employeeLevel == 80 ){
                    this.active = 1
                    this.stepList = [
                        {name:'',index:0,title:'提交'},
                        {name:'',index:1,title:'BU审批中'},
                        {name:'',index:2,title:'执行中'},
                        {name:'',index:3,title:'完成'},
                    ]

                } else if  (this.employeeLevel == 90 || this.employeeLevel == 100  ){
                    this.active = 2
                    this.stepList = [
                        {name:'',index:0,title:'提交'},
                        {name:'',index:1,title:'BU已审批'},
                        {name:'',index:2,title:'执行中'},
                        {name:'',index:3,title:'完成'},
                    ]
                }
            }
            this.activityInfo = activityInfo
            this.getShowDetail()
            // console.log(activityInfo,'activityInfo');
            let tableList = []
            let gpActivityPocDTOList = activityInfo.gpActivityPocDTOList || []
            let oldtimeList =  activityInfo.gpActivityTimeDTOList || []
            let timeList = oldtimeList.map((item)=>{return item.activityTime})
            let blockName = activityInfo.blockName
            let buName = activityInfo.buName
            let regionName = activityInfo.regionName
            let activityStatus = activityInfo.activityStatus
            let bwContactPerson = activityInfo.bwContactPerson
            let areaCode = activityInfo.areaCode
            let regionCode =  activityInfo.regionCode
            let submitRejectReason = activityInfo.submitRejectReason
            let rejectClientName = activityInfo.rejectClientName
            let rejectClientLevel = activityInfo.rejectClientLevel
            let blockAddress = activityInfo.blockAddress
            let areaName = activityInfo.areaName
            let activityId = activityInfo.activityId
            let obj = {}
            if (activityInfo.gpThemeDetailDTO.pocRelateType == '0') {
                obj.blockName = blockName
                obj.buName = buName
                obj.regionName = regionName
                obj.activityStatus = activityStatus
                obj.bwContactPerson = bwContactPerson
                obj.areaCode = areaCode
                obj.timeList = timeList
                obj.timeListno = timeList
                obj.regionCode = regionCode
                obj.submitRejectReason = submitRejectReason
                obj.rejectClientName = rejectClientName
                obj.rejectClientLevel = rejectClientLevel
                obj.blockAddress = blockAddress
                obj.areaName = areaName
                obj.activityId = activityId
                tableList.push(obj)
            } else {
                for (const item of gpActivityPocDTOList) {
                    item.blockName = blockName
                    item.buName = buName
                    item.regionName = regionName
                    item.activityStatus = activityStatus
                    item.bwContactPerson = bwContactPerson
                    item.areaCode = areaCode
                    item.timeList = timeList
                    item.timeListno = timeList
                    item.regionCode = regionCode
                    item.submitRejectReason = submitRejectReason
                    item.rejectClientName = rejectClientName
                    item.rejectClientLevel = rejectClientLevel
                    item.blockAddress = blockAddress
                    item.areaName = areaName
                    item.activityId = activityId
                    tableList.push(item)
                }
            }
            this.tableList = tableList
            this.dataItem = {
                'themeDetail':activityInfo.gpThemeDetailDTO,
                'gpActivityInfoVOList':this.tableList,
            }
            this.loading = false
            this.getShowtext()
            // this.getDetailinfo()
            }
        },
        gamepalnActivityapprove (params) {
            gameplanApi.getGamepalnActivityapprove(params).then(res=>{
                if (res.data.resultCode === '0') {
                    if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '02') {
                        if (this.isPassThroughall == true) {
                            this.$message.success('您已通过全部售点活动提报审批');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('您已通过售点活动提报审批');
                            this.$router.go(-1)
                        }
                    } else if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '03') {
                        if ((this.isSendbackall == true)) {
                            this.$message.success('您已退回全部售点活动提报审批');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('您已退回售点活动提报审批');
                            this.$router.go(-1)
                        }
                    }
                    this.loading = false
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        getIgniteoptions () {
            gameplanApi.getIgniteoptions().then(res=>{
                if (res.data.resultCode == '0') {
                    this.activityIgnite = res.data.resultData.igniteOptions
                }
            })
        },
        // 明细显示隐藏
        collClick (name) {
        if (name == 'orderShow1') {
            this.orderShow1 = !this.orderShow1
        } else if (name == 'orderShow2') {
            this.orderShow2 = !this.orderShow2
        } else if (name == 'orderShow3') {
            this.orderShow3 = !this.orderShow3
        } else if (name == 'orderShow4') {
            this.orderShow4 = !this.orderShow4
        } else if (name == 'orderShow5') {
            this.orderShow5 = !this.orderShow5
        }
        },
        clickStorename (row) {
            this.$router.push({path:'/gameplan/activityPhoto-salePlace-detail',query:{activityId:row.activityId,lastQuery:'submit'}})

        },
        // 通过
        passThrough (item) {
            console.log(item,'item');
            let newArr= [];
            let arrId = [];
            for(let i of item){
                if(arrId.indexOf(i['activityId']) == -1){
                    arrId.push(i['activityId']);
                    newArr.push(i);
                }
            }
            let arr = []
            for (let i of newArr) {
                arr.push({gpActivityInfoDTO:{
                        processType: '02',
                        processAction: '02',
                        activityId: i.activityId
                }})

            }
            let params = {
                activityInfoVOList: arr
            }
            this.loading = true
            this.gamepalnActivityapprove(params)
        },
        // 退回
        sendBack (obj) {
            let item = obj.item
            let newArr= [];
            let arrId = [];
            for(let i of item){
                if(arrId.indexOf(i['activityId']) == -1){
                    arrId.push(i['activityId']);
                    newArr.push(i);
                }
            }
            let arr = []
            for (let i of newArr) {
                arr.push({gpActivityInfoDTO:{
                        processType: '02',
                        processAction: '03',
                        activityId: i.activityId,
                        submitRejectReason:obj.rejectAccount,
                        submitRejectPerson:this.userInfo.clientName,
                }})
            }
            let params = {
                activityInfoVOList: arr
            }
            this.loading = true
            this.gamepalnActivityapprove(params)
        },
        // 全部通过
        passThroughall () {
           let ThemeInfoVO = {
            activityInfoVOList:[]
            }
            // 新加
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            for (let i = 0; i < testDatalist.length; i++) {
                if (testDatalist[i].gpActivityInfoVOList == null) {
                    testDatalist.splice(i, 1);
                    i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
                }
            }
            let newArr1 = []
            for (let i = 0; i < testDatalist.length; i++) {
                for (let j = 0; j <  testDatalist[i].gpActivityInfoVOList.length; j++) {
                    newArr1.push(testDatalist[i].gpActivityInfoVOList[j])
                }

            }
            // console.log(newArr1,'newArr1-全部通过');
            if (testDatalist.length == 0) {
                // this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let arr = []
                for (let item of newArr1) {
                    arr.push(
                        {gpActivityInfoDTO:{
                        processType:'02',
                        processAction:'02',
                        activityId:item.gpActivityInfoDTO.activityId,
                    }})
                }
                ThemeInfoVO.activityInfoVOList = arr
                // console.log(ThemeInfoVO,'ThemeInfoVO-全部通过');
                this.isPassThroughall = true
                this.loading = true
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        // 全部退回
        sendBackall () {
            let ThemeInfoVO = {
                activityInfoVOList:[]
            }
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            for (let i = 0; i < testDatalist.length; i++) {
                if (testDatalist[i].gpActivityInfoVOList == null) {
                    testDatalist.splice(i, 1);
                    i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
                }
            }
            let newArr1 = []
            for (let i = 0; i < testDatalist.length; i++) {
                for (let j = 0; j <  testDatalist[i].gpActivityInfoVOList.length; j++) {
                    newArr1.push(testDatalist[i].gpActivityInfoVOList[j])
                }
            }
            // console.log(newArr1,'newArr1-全部退回');
            if (testDatalist.length == 0) {
                // this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let arr = []
                for (let i = 0; i < newArr1.length;i++) {
                    arr.push(
                        {
                            'gpActivityInfoDTO':
                            {
                                processType:'02',
                                processAction:'03',
                                activityId:newArr1[i].gpActivityInfoDTO.activityId,
                                submitRejectReason:this.rejectAccount,
                                submitRejectPerson:this.userInfo.clientName,
                            },
                            'gpActivityPocDTOList':[]
                        }
                    )
                    if (newArr1[i].gpActivityPocDTOList !== null) {
                        for (let item2 of newArr1[i].gpActivityPocDTOList) {
                            arr[i].gpActivityPocDTOList.push({
                                activityPocId:item2.activityPocId,
                                rejectStatus:item2.rejectStatus,
                                rejectReason:item2.rejectReason,
                            })
                        }
                    }
                }
                ThemeInfoVO.activityInfoVOList = arr
                // console.log(ThemeInfoVO,'ThemeInfoVO-全部退回');
                this.isSendbackall = true
                this.loading = true
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        // 返回上一页
        goReturn () {
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        .activity-new {
            .activity-new-card {
                padding: 10px 10px 10px 20px;
                background-color: #FFFFFF;
                color: #101010;
                border-radius: 8px;
                .title {
                    color: #101010;
                    text-align: left;
                    font-family: SourceHanSansSC-medium;
                    margin-bottom: 5px;
                    display: flex;
                    .left {
                        line-height: 32px;
                        flex: 1;
                        font-size: 20px;
                        font-weight: 600;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                        margin-right: 20px;
                    }
                    .right {
                        height: 32px;
                        line-height: 32px;
                        font-size: 14px;
                        display: flex;
                        color: #FFFFFF;
                        text-align: center;
                    }
                }
                .step {
                    // height: 100px;
                    // line-height: 100px;
                    ::v-deep .el-step__title {
                        color:#666666;
                    }
                    ::v-deep .el-step__title.is-success {
                        color: #101010;
                    }
                    ::v-deep .el-step__head.is-success .el-step__line-inner {
                        background-color: #101010;
                    }
                    ::v-deep .el-step__head.is-success {
                        color: #CD1231;
                        border-color: #CD1231;
                    }
                    ::v-deep .el-step__title.is-process {
                        // font-weight: 700;
                        // color: #303133;
                        font-weight: 500;
                        color: #666666;
                    }
                    ::v-deep .el-step__head.is-process {
                        color: #CD1231;
                        border-color: #CD1231;
                    }
                }
            }
        }
        .btn-bottom {
            height: 30px;
            line-height: 30px;
            width: 100px;
            margin: 0px auto  ;
            margin-top: 50px;

        }
        .title {
            line-height: 40px;
            text-align: left;
            color: #101010;
            font-size: 18px;
            font-weight: 600;
        }
        .card-box {
            .card {
                display: flex;
                justify-content: flex-start;
                padding:10px  20px;
                background-color: #FFFFFF ;
                border-radius: 10px;
                font-size: 14px;
                .left {
                    flex: 1;
                    text-align: left;
                    color: #101010;
                    .left-top {
                        display: flex;
                        .left {
                            width: 70%;
                            font-size: 18px;
                            display: flex;
                            .top-name {
                                // padding: 2px 0px;
                                font-weight: 600;
                                word-wrap: break-word;
                                word-break: normal;
                                word-break: break-all;
                            }
                            .top-sign {
                                // padding: 2px 8px;
                                color: #FFFFFF;
                                background-color: #40A5EE;
                                margin-left: 10px;
                                // border-radius: 3px;
                                // height: 20px;
                                padding: 0px 8px;
                                line-height: 18px;
                                height: 18px;
                                font-size: 14px;
                                margin-top: 1px;
                                font-weight: 600;
                            }
                        }
                        .right {
                            flex: 1;
                            line-height: 20px;
                            font-size: 14px;
                            text-align: right;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                    }
                    .fouth {
                        font-size: 14px;
                        line-height: 20px;
                        color: #101010 ;
                        margin-top: 15px;
                        display: flex;
                        .fouth-left {
                            display: flex;
                            .first-center {
                                height: 15px;
                                line-height: 15px;
                                padding: 3px 10px;
                                text-align: center;
                                border-radius: 4px;
                                border: 1px solid #539EFE;
                                background-color: #FFFFFF;
                                color: #539EFE;
                                margin-left: 20px;
                                margin-top: -1px;
                            }
                        }
                        .fouth-right {
                            // color: #999999 ;
                            flex: 1;
                            margin-left: 50px;

                        }
                    }
                    .left-third {
                        font-size: 14px;
                        height: 20px;
                        line-height: 20px;
                        margin-top: 12px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            display: flex;
                            justify-content: flex-start;
                            margin-right: 80px;
                        }
                        .left-third-right {
                            display: flex;
                            justify-content: flex-start;
                            .img {
                            width: 20px;
                            margin-right: 3px;
                            }
                            // .text {
                            //     margin: 0px 3px 0px 3px ;
                            //     // color: #539EFE;
                            // }
                        }
                    }
                    .left-fouth {
                        display: flex;
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 12px;
                        .left-fouth-left {
                            width: 70px;
                        }
                        .left-fouth-right {
                            flex: 1;
                        }
                    }
                }
                .right {
                    text-align: right;
                    .right-top {
                        line-height: 27px;
                        color: #999999;
                        font-size: 16px;
                    }
                }
            }
        }
        .card-box2 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                display: flex;
                flex-wrap: wrap;
                padding-left: 8px;
                .item {
                    width: 50%;
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 148px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
                .item-sign {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    padding-left: 104px;
                    .sign {
                        display: flex;
                        margin: 0px 15px;
                        .sign-left {
                            margin-right: 5px;
                            font-weight: normal;
                            line-height: 33px;
                        }
                        .sign-right {
                            margin-top: 3px;
                            .color-green {
                                color: rgb(42, 219, 33);
                                font-size: 18px;
                            }
                            .color-red {
                                color: rgb(219, 93, 33);
                                font-size: 18px;
                            }
                        }
                    }
                }
            }
        }
        .card-box3 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                padding-left: 8px;
                .item {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 127px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
            }
        }
        .changePop {
            position: fixed;
            top: 5vh;
            left: calc((100vw - 800px)/2);
            width: 800px;
            padding: 20px;
            background-color: #FFFFFF;
            border-radius: 10px;
            z-index: 3;
            max-height: 90vh;
        }
        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.7) ;
            z-index: 3;
        }
    }
  .pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
